export default "__VITE_ASSET__3VOqSJMS__"